import { useEffect } from 'react';
import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import Main from './components/layout/Main';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { Route, BrowserRouter  as Router, Routes } from 'react-router-dom';
import { PortafolioDetails } from './components/pages/PortafolioDetails';
import { ServiceDetails } from './components/pages/ServiceDetails';

function App() {

  useEffect(() => {
    AOS.init({
      duration: 600, // Duración de la animación en milisegundos
      easing: 'ease-in-out', // Tipo de easing para la animación
      once: true, // Si `true`, la animación solo se ejecuta una vez
      mirror: false // Si `true`, permite que se repita la animación al hacer scroll hacia arriba
    });
  }, []);

  return (
    <Router className="index-page">
      <Header></Header>
      <main style={{minHeight: '90vh'}}>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/:idSection" element={<Main />} />
          <Route path="/portfolio-details/:id" element={<PortafolioDetails />} />
          <Route path="/service-details/:id" element={<ServiceDetails />} />
          <Route path="*" element= {()=> <h1>404</h1>} />
        </Routes>
      </main>
      <Footer></Footer>
    </Router>
  );
}

export default App;
